// Function index:
//   myCharacters(worldId?)             — caller's characters + slot usage, optional world filter.
//   createCharacter(body)              — create (optionally with party_id to assign).
//   assignCharacter(charId, partyId)   — assign or move a character to a party.
//   retireCharacter(characterId)       — soft-retire, frees a tier slot.
//   getInventory(characterId)          — read a character's inventory.
//   spendSkillPoint(charId, skill)     — spend one skill_points to raise a
//       curated skill by a rank (opens at 1 if new); mirrors the server's
//       verbatim 400s (POST /api/characters/:id/skills/spend).

import { getJson, postJson } from './http.js';
import type { CharacterRow, InventoryItem } from './types.js';

export const myCharacters = (worldId?: number): Promise<{ characters: CharacterRow[]; slots: { used: number; cap: number } }> =>
  getJson(`/api/characters/me${worldId ? `?world_id=${worldId}` : ''}`);

export const createCharacter = (body: {
  world_id: number;
  name: string;
  description?: string;
  sheet?: unknown;
  class?: string | null;
  stats?: Record<string, number>;
  skills?: Record<string, number>;
  // Adventurer creation only: two distinct curated skill names (rank 1
  // each); ignored server-side for any other archetype.
  pick_skills?: [string, string];
  party_id?: number;
  start_q?: number;
  start_r?: number;
}) => postJson<{ character_id: number }>('/api/characters', body);

export const getInventory = (characterId: number): Promise<{ inventory: InventoryItem[] }> =>
  getJson(`/api/characters/${characterId}/inventory`);

export const spendSkillPoint = (characterId: number, skill: string): Promise<{ ok: true; skill: string; rank: number; skill_points: number }> =>
  postJson(`/api/characters/${characterId}/skills/spend`, { skill });

export const assignCharacter = (characterId: number, partyId: number) =>
  postJson<{ assigned?: boolean; already_assigned?: boolean }>(
    `/api/characters/${characterId}/assign`,
    { party_id: partyId },
  );

export const retireCharacter = (characterId: number) =>
  postJson<{ retired: true }>(`/api/characters/${characterId}/retire`, {});
